import { Injectable } from "@angular/core";
import { Effect, ofType, Actions } from "@ngrx/effects";
import { switchMap, mergeMap } from "rxjs/operators";
import { of } from "rxjs";
import { ELanguageActions, SetLanguages } from "@edp-store/actions/language.actions";
import { LanguageService } from "@edp-services/language.service";


@Injectable()
export class LanguageEffects {
    @Effect()
    getLanguages = this.actions$.pipe(
        ofType(ELanguageActions.GetLanguages),
        switchMap(() => this.languageService.getLanguages()),
        mergeMap((data) => {
            if (!(data instanceof Error)) {
                return of(new SetLanguages(data));
            }
        })
    );

    constructor(
        private readonly actions$: Actions,
        private readonly languageService: LanguageService
    ) { }

}
